import { render, staticRenderFns } from "./OrganizationRegistrationForm.vue?vue&type=template&id=ceec2e26&scoped=true&"
import script from "./OrganizationRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec2e26",
  null
  
)

export default component.exports